export default "__VITE_ASSET__CD_oAQ7o__"